import React from 'react';
import markdownContent from '!!raw-loader!static/terms.md';
import { Markdown } from 'Common';

export const TermsPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};

export default TermsPage;
